// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1gISmrsz","section":"_2Bj-uYz0","content":"_2k5muODm","cards-container":"HYTFmdMV","first-card":"B8Z_U1sz","containerLink":"_1YmGVAq5","otherDes":"iudHp1KY","linkTitle":"_2NV231-u","linkBig":"_10MfVcEm","challenge-container":"_2sR83DzB","buttonDown":"_3K5wh2gz","arrowDiv":"_1_x_TR0M","arrowIcon":"_1Kd2vxbA"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/Challenges/Challenges.styl
// module id = 206
// module chunks = 0